import { Box, Divider, Stack, Typography } from "@mui/material";
import {
  Dispatch,
  forwardRef,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { NewUser } from "../../types";
import { AddedUsersList } from "./AddedUsersList";
import { AddNewUser } from "./AddNewUser";
import { validateNewUserInputAndAddToList } from "./helpers";

const AddUserManualComponent = forwardRef(
  (
    {
      setNewUsers,
      newUsers,
      userErrors,
      setUserErrors,
    }: {
      setNewUsers: Dispatch<SetStateAction<any>>;
      newUsers: NewUser[];
      userErrors: any;
      setUserErrors: Dispatch<SetStateAction<any>>;
    },
    ref,
  ) => {
    const [isUserPrivileged, setIsUserPrivileged] = useState(false);
    const [emailTextFieldValue, setEmailTextFieldValue] = useState("");
    const [fullNameTextFieldValue, setFullNameTextFieldValue] = useState("");
    const [
      fullNameAndEmailTextFieldValueError,
      setFullNameAndEmailTextFieldValueError,
    ] = useState("");

    useEffect(() => {
      if (!emailTextFieldValue && fullNameAndEmailTextFieldValueError) {
        setFullNameAndEmailTextFieldValueError("");
      }
    }, [emailTextFieldValue]);

    useImperativeHandle(ref, () => ({
      onAddUserClick: () => {
        const validation = validateNewUserInputAndAddToList({
          fullName: fullNameTextFieldValue,
          setFullName: setFullNameTextFieldValue,
          email: emailTextFieldValue,
          setEmail: setEmailTextFieldValue,
          newUsersInDrawer: newUsers,
          setNewUsersInDrawer: setNewUsers,
          setAddNewUserError: setFullNameAndEmailTextFieldValueError,
          isUserPrivileged: isUserPrivileged,
        });
        if (validation) {
          return {
            userList: [
              ...(emailTextFieldValue && fullNameTextFieldValue
                ? [
                    {
                      full_name: fullNameTextFieldValue.trim(),
                      email: emailTextFieldValue.trim(),
                      IsPrivileged: isUserPrivileged,
                    },
                  ]
                : []),
              ...newUsers,
            ],
          };
        }
        return null;
      },
    }));

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
          flex: 1,
          justifyContent: "space-between",
          px: "32px",
        }}
      >
        <Stack gap={"24px"}>
          <Typography variant="h4">Add User Details to Get Started</Typography>
          <AddNewUser
            email={emailTextFieldValue}
            setEmail={setEmailTextFieldValue}
            fullName={fullNameTextFieldValue}
            setFullName={setFullNameTextFieldValue}
            isPrivileged={isUserPrivileged}
            setIsPrivileged={setIsUserPrivileged}
            newUsers={newUsers}
            setNewUsers={setNewUsers}
            addNewUserError={fullNameAndEmailTextFieldValueError}
            setAddNewUserError={setFullNameAndEmailTextFieldValueError}
          />
          <Divider />
          {/* maping user component  */}
          <Stack>
            <Stack sx={{ padding: "0px 0px 12px 0px" }}>
              <Typography variant="body-medium">
                Users Added : {newUsers.length}
              </Typography>
            </Stack>
            <AddedUsersList
              newUsers={newUsers}
              setNewUsers={setNewUsers}
              setUserErrors={setUserErrors}
            />
            <Stack
              sx={{
                maxHeight: "200px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {userErrors.map((item: any, index: any) => (
                <>
                  <Stack
                    direction={"row"}
                    sx={{
                      justifyContent: "space-between",
                      padding: "8px 12px",
                    }}
                  >
                    <Typography
                      variant="body-small"
                      sx={{
                        display: "inline-block",
                        maxWidth: "350px",
                        whiteSpace: "noWrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: "red",
                      }}
                    >
                      {item.message && `${item.message}`}
                    </Typography>
                  </Stack>
                </>
              ))}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    );
  },
);

export default AddUserManualComponent;
